import { Typography, Box } from "@mui/material";

const Section = ({ id, title, children }) => {

    return (
        <Box id={id} sx={{ scrollMarginTop: 80, mb: 6 }}>
            <Typography
                variant="h4"
                gutterBottom
                sx={theme => ({
                color: theme.palette.accent.main
            })}>
                {title}
            </Typography>
            {children}
        </Box>
    );
};

export default Section;
